import { useCallback } from "react";
import { loadStripe } from "@stripe/stripe-js";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
import api from "../../axios/axios"; // Import your axios instance
import { useDispatch, useSelector } from "react-redux";
import { setSelectedAddress } from "../../redux/features/auth/userSlice";

// Load Stripe outside of the component render to avoid recreating it on every render.
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const CheckoutForm = () => {
  const dispatch = useDispatch();
  const selectedAddress = useSelector((state) => state.user.selectedAddress);
    const checkOutDetails = useSelector((state) => state.user.checkoutDetails);
  
  const cart = useSelector((state) => state.user.cart);
  const currentUser = useSelector((state) => state.user.currentUser);

  const fetchClientSecret = useCallback(async () => {
    try {
      const response = await api.post("user/create-checkout-session", {
        cart,
        checkOutDetails,
        userId: currentUser._id, // Pass userId to the backend
        selectedAddress, // Pass selectedAddress to the backend
      });
      // Reset the selected address after session creation
      dispatch(setSelectedAddress(null));
      return response.data.clientSecret;
    } catch (error) {
      throw new Error("Failed to fetch client secret.");
    }
  }, [cart, currentUser, selectedAddress, dispatch]); // Add dependencies

  const options = { fetchClientSecret };

  return (
    <div id="checkout">
      <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
};

export default CheckoutForm;